<h2 mat-dialog-title i18n>
  <span *ngIf="mode === 'create'">Add</span>
  <span *ngIf="mode === 'update'">Edit</span>
  <span *ngIf="mode === 'replace'">Replace</span>
  Connection
</h2>
@let form = $connectionForm();
<mat-dialog-content>
  <ub-alert variant="danger" *ngIf="mode === 'replace'">
    <span message i18n>This is going to disconnect all associated booking items and reconnect with the
    new connection.</span>
  </ub-alert>

  <eas-easform-group [easGroup]="form.group"></eas-easform-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    mat-stroked-button
    color="accent"
    (click)="onCancel()"
    i18n>
    Cancel
  </button>
  <button
    *ngIf="mode === 'create' || mode === 'replace'"
    mat-flat-button
    color="primary"
    [disabled]="!form.group.control?.valid"
    (click)="onInitRegistration()"
    i18n>
    {{mode === 'create' ? 'Register' : 'Replace'}}
  </button>
  <button
    *ngIf="mode === 'update'"
    mat-flat-button
    color="primary"
    [disabled]="!form.group.control?.valid"
    (click)="onUpdateConnection()"
    i18n>
    Edit
  </button>
</mat-dialog-actions>
